import React, { ReactNode } from "react"
import { Link, useLocation } from "react-router-dom"
import {
	ListItem,
	ListItemIcon,
	ListItemText,
	MenuItem,
	Grid
} from "@material-ui/core"

import { deviceIsMobile } from "@/utils/checkDevice"

import useStyles from "@/components/ListItemMenu/styles"
import FeatureStatusChip from "@/components/FeatureStatusChip"
import clsx from "clsx"

export type FeatureType = "new" | "upcoming"

export type ListItemMenuProps = {
	to?: string
	icon?: ReactNode
	text?: string
	isExternalLink?: boolean
	featureType?: FeatureType
	isDisabled?: boolean
	disabled?: boolean
	listItemTextClass?: string
	iconClass?: string
	listItemIcon?: React.ReactElement
	listItemText?: React.ReactElement
	onClick?: (
		e: React.MouseEvent<HTMLElement>
	) => void
}

const ListItemMenu: React.FC<ListItemMenuProps> = (props) => {
	const { to = "", icon, text, isExternalLink, onClick, featureType, isDisabled, disabled, iconClass, listItemTextClass, listItemIcon, listItemText } = props

	const classes = useStyles()

	const location = useLocation()

	const isMenuItemActive = (route: string) => location.pathname.includes(route)
	const isMenuItemWithoutAction = !to

	const hasFeatureBadge = !!featureType

	function getFeatureStatusChip () {
		if (featureType) {
			return <FeatureStatusChip status={featureType} />
		}
	}

	const renderedIcon = listItemIcon || (icon && (
		<ListItemIcon className={clsx(classes.listItemIcon, iconClass)}>
			{icon}
		</ListItemIcon>
	))

	const renderedText = listItemText || (text && (
		<ListItemText
			primary={text}
			className={clsx(listItemTextClass, { [classes.newFeatureListItemText]: hasFeatureBadge })}
		/>
	))

	if (isMenuItemWithoutAction) {
		return (
			<MenuItem
				component="a"
				onClick={onClick}
				className={classes.menuItem}
			>
				{renderedIcon}
				{renderedText}
			</MenuItem>
		)
	} else {
		if (isExternalLink) {
			return (
				<MenuItem
					component="a"
					href={to}
					target={deviceIsMobile() ? "_SELF" : "_BLANK"}
					onClick={onClick}
					disabled={isDisabled || disabled}
					className={clsx(classes.menuItem, { [classes.disabledMenuItem]: isDisabled || disabled })}
				>
					{renderedIcon}
					{renderedText}
					{getFeatureStatusChip()}
				</MenuItem>
			)
		} else {
			return (
				<Grid alignItems="center" justifyContent="center" className={classes.listItemMenuLine}>
					<ListItem
						button
						component={Link}
						to={to}
						key={to}
						className={`${isMenuItemActive(to) ? classes.listItemActive : ""}`}
						disabled={isDisabled || disabled}
					>
						{renderedIcon}
						{renderedText}
						{getFeatureStatusChip()}
					</ListItem>
				</Grid>
			)
		}
	}
}

export default ListItemMenu
